import {Component} from 'react';
import {WebSocketsClient} from "./WebSocketsClient";

export class WebSocketEvent extends Component {
    componentDidMount() {
        // `bind` resuelve la config del backend por dentro (qué cuenta del pool y qué canal
        // de la agencia) y devuelve la función para desengancharse.
        this._unbind = WebSocketsClient.bind(this.props.channelId, this.props.eventId, this.props.onEventTriggered);
    }

    componentWillUnmount() {
        if (this._unbind) this._unbind();
    }

    render() {
        return null;
    }
}
